import { IdentityGroupAri } from '@atlassian/ari';

// group IDs are UUIDs so `everyoneelse` won't conflict with existing groups
export const everyoneElseAri = IdentityGroupAri.create({
  groupId: 'everyoneelse'
});
export const FORM_RESTRICTION_URL = 'https://support.atlassian.com/jira-service-management-cloud/docs/restrict-who-can-view-forms/';
export const BUTTON_SPOTLIGHT_TARGET_NAME = 'proforma-form-security-button-spotlight-target';